import { defineMessage, FormattedMessage } from 'react-intl';
import React from 'react';
import { CREATIVE_MODES, ENVIRONMENT } from '../../constants';

export const IS_EMBEDDED =
  (self && self.IS_EMBEDDED) || ENVIRONMENT.IS_EMBEDDED;

export const PROJECT_OPTIONS = {
  CONVERT: 'CONVERT',
  CUSTOMIZE: 'CUSTOMIZE',
  DESIGN: 'DESIGN',
};

export const PROJECT_OPTION_ORDER = [
  PROJECT_OPTIONS.CONVERT,
  PROJECT_OPTIONS.CUSTOMIZE,
  PROJECT_OPTIONS.DESIGN,
];

export const PROJECT_TABS = {
  PROJECTS: 'PROJECTS',
  TEMPLATES: 'TEMPLATES',
  GLOBAL_TEMPLATES: 'GLOBAL_TEMPLATES',
};

export const PROJECT_TABS_ORDER = [
  PROJECT_TABS.PROJECTS,
  PROJECT_TABS.TEMPLATES,
  PROJECT_TABS.GLOBAL_TEMPLATES,
];

export const PROJECT_OPTION_CONFIG = {
  [PROJECT_OPTIONS.CONVERT]: {
    description: defineMessage({
      defaultMessage:
        'Convert your existing wide-screen or square video to vertical for Snapchat.',
      description: 'Subtext for Convert action button',
    }),
    title: defineMessage({
      defaultMessage: 'Convert a Video to Vertical',
      description: 'Main text for Convert action button',
    }),
    url: '/projects/convert/new',
  },
  [PROJECT_OPTIONS.CUSTOMIZE]: {
    description: defineMessage({
      defaultMessage:
        'Pick a template and customize it to make a new vertical video.',
      description: 'Subtext for Customize action button',
    }),
    title: defineMessage({
      defaultMessage: 'Customize a Video Template',
      description: 'Main text for Customize action button',
    }),
    url: '/projects/customize/new',
  },
  [PROJECT_OPTIONS.DESIGN]: {
    description: defineMessage({
      defaultMessage:
        'Design a completely new vertical video with our powerful animation tools.',
      description: 'Subtext for Design action button',
    }),
    title: defineMessage({
      defaultMessage: 'Design from Scratch',
      description: 'Main text for Design action button',
    }),
    url: '/projects/design/new',
  },
};

export const PHOTO_LABEL = (
  <FormattedMessage
    defaultMessage='Photo'
    description='Label, dropdown item for Photo project type'
  />
);

export const CUSTOMIZE_LABEL = (
  <FormattedMessage
    defaultMessage='Customize'
    description='Label, dropdown item for Customize project type'
  />
);

export const CONVERT_LABEL = (
  <FormattedMessage
    defaultMessage='Convert'
    description='Label, dropdown item for Convert project type'
  />
);

export const DESIGN_LABEL = (
  <FormattedMessage
    defaultMessage='Design'
    description='Label, dropdown item for Design project type'
  />
);

export const PROJECT_DUPLICATE_MESSAGE = (
  <FormattedMessage
    defaultMessage='The duplicate was created and has been added to your projects.'
    description='Success message for duplicate action'
  />
);

export const PROJECT_LIST_EMPTY_PRIMARY_MESSAGE = (
  <FormattedMessage
    defaultMessage='Start a new project by using the buttons above'
    description='Empty state for project list, first line'
  />
);

export const PROJECT_LIST_EMPTY_SECONDARY_MESSAGE = (
  <FormattedMessage
    defaultMessage='or begin by customizing a video template.'
    description='Empty state for project list, second line'
  />
);

export const PROJECT_LIST_EMPTY_CALL_TO_ACTION = (
  <FormattedMessage
    defaultMessage='Customize a Video Template'
    description='Empty state CTA for project list'
  />
);

export const ALL_FILTER_LABEL = (
  <FormattedMessage
    defaultMessage='All'
    description='Label, dropdown item for All project types'
  />
);

export const DESIGN_FILTER_LABEL = (
  <FormattedMessage
    defaultMessage='Design'
    description='Label, dropdown item for Design project type'
  />
);

export const CUSTOMIZE_FILTER_LABEL = (
  <FormattedMessage
    defaultMessage='Customize'
    description='Label, dropdown item for Customize project type'
  />
);

export const CONVERT_FILTER_LABEL = (
  <FormattedMessage
    defaultMessage='Convert'
    description='Label, dropdown item for Convert project type'
  />
);

export const FILTER_LABEL_MAP = {
  [CREATIVE_MODES.ADVANCED]: DESIGN_FILTER_LABEL,
  [CREATIVE_MODES.SIMPLE]: CUSTOMIZE_FILTER_LABEL,
  [CREATIVE_MODES.SHOWS]: CONVERT_FILTER_LABEL,
};

export const TEMPLATE_LIST_EMPTY_PRIMARY_MESSAGE = (
  <FormattedMessage
    defaultMessage='Make your own template by customizing'
    description='Empty state for template list, first line'
  />
);

export const TEMPLATE_LIST_EMPTY_SECONDARY_MESSAGE = (
  <FormattedMessage
    defaultMessage='one of the starter templates below or'
    description='Empty state for template list, second line'
  />
);

export const TEMPLATE_LIST_NEW_TEMPLATE = (
  <FormattedMessage
    defaultMessage='Create New Template'
    description='Empty state and button CTA for template list'
  />
);

export const TEMPLATE_LIST_NEW_GLOBAL_TEMPLATE = (
  <FormattedMessage
    defaultMessage='Create New Global Template'
    description='Button CTA to create a new global template (admin only)'
  />
);
